import type { HabitRecord } from '../core/types.js';
import { CATEGORY_TO_DOMAIN, defaultMethodForLegacyHabit } from '../domain/default-methods.js';
import { nowIso } from '../core/time.js';
import { consumptionMethods, habits, metaGet, metaSet } from './db.js';

function ensureDomainOnHabit(h: HabitRecord): HabitRecord {
  const needsDomain = !h.domain;
  const needsSchemaBump = h.schemaVersion < 2;
  if (!needsDomain && !needsSchemaBump) return h;
  const domain = h.domain ?? CATEGORY_TO_DOMAIN[h.category] ?? 'other';
  return { ...h, domain, schemaVersion: 2, updatedAt: nowIso() };
}

/**
 * Idempotent: backfill `domain` on legacy habits and ensure each active habit
 * has at least one consumption method. Records completion in app_meta.
 */
export async function ensurePhase2Migration(): Promise<void> {
  const done = await metaGet('phase2_methods_migrated_at');
  if (done) return;

  const all = await habits.all();
  for (const habit of all) {
    const updated = ensureDomainOnHabit(habit);
    if (updated !== habit) await habits.put(updated);
    if (!updated.active) continue;
    const existing = await consumptionMethods.byHabit(updated.id);
    if (existing.length === 0) {
      await consumptionMethods.put(defaultMethodForLegacyHabit(updated));
    }
  }

  await metaSet('phase2_methods_migrated_at', nowIso());
  await metaSet('schema_version', 2);
}
